import { render, staticRenderFns } from "./recommendAdvertList.vue?vue&type=template&id=c7f84958&scoped=true"
import script from "./recommendAdvertList.vue?vue&type=script&lang=ts"
export * from "./recommendAdvertList.vue?vue&type=script&lang=ts"
import style0 from "./recommendAdvertList.vue?vue&type=style&index=0&id=c7f84958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f84958",
  null
  
)

export default component.exports